if (!customElements.get('drop-hero-countdown')) {
  class DropHeroCountdown extends HTMLElement {
    connectedCallback() {
      this.target = new Date(this.dataset.target).getTime();
      this.preDrop = this.querySelector('[data-hero-state="pre-drop"]');
      this.live = this.querySelector('[data-hero-state="live"]');
      this.values = {
        days: this.querySelector('[data-countdown="days"]'),
        hours: this.querySelector('[data-countdown="hours"]'),
        minutes: this.querySelector('[data-countdown="minutes"]'),
        seconds: this.querySelector('[data-countdown="seconds"]'),
      };

      if (!this.target || Number.isNaN(this.target)) return;

      this.tick();
      this.interval = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    tick() {
      const remaining = this.target - Date.now();

      if (remaining <= 0) {
        this.goLive();
        return;
      }

      this.setValue('days', Math.floor(remaining / 86400000));
      this.setValue('hours', Math.floor((remaining % 86400000) / 3600000));
      this.setValue('minutes', Math.floor((remaining % 3600000) / 60000));
      this.setValue('seconds', Math.floor((remaining % 60000) / 1000));
    }

    setValue(unit, value) {
      const el = this.values[unit];
      if (el) el.textContent = String(value).padStart(2, '0');
    }

    goLive() {
      window.clearInterval(this.interval);
      if (this.preDrop) this.preDrop.hidden = true;
      if (this.live) this.live.hidden = false;
      this.classList.add('is-live');
    }
  }

  customElements.define('drop-hero-countdown', DropHeroCountdown);
}
